"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadBlob = exports.exportCSVFromFiles = exports.downloadFiles = exports.downloadOrOpenFiles = void 0;
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var cookies_1 = require("utils/cookies");
var sort_1 = require("utils/sort");
var shortenUrl = new URL('/files/generate-url', __UPLOADSERVERURL__);
var fileSortingFn = (0, sort_1.sortFoldersAndFiles)({
    identifier: 'name-meta'
})('asc');
var downloadOrOpenFiles = function (files, token, allVersions, dispatch) {
    var isExactlyOneFileSelected = files.length === 1 && files[0].type !== 'FOLDER';
    if (!allVersions && isExactlyOneFileSelected) {
        window.open(__UPLOADSERVERURL__ + '/files/' + files[0].uuid, '_blank');
        return;
    }
    var uuid = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0)).payload.uuid;
    (0, exports.downloadFiles)(token, files, undefined, undefined, function () { return dispatch(ToastActions.removeToast(uuid)); }, {
        includeSubFolders: 'true',
        includeSelf: 'true',
        allVersions: allVersions.toString()
    });
};
exports.downloadOrOpenFiles = downloadOrOpenFiles;
var downloadFiles = function (token, files, urls, onStart, onComplete, queryParams) {
    if (urls === void 0) { urls = []; }
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('POST', shortenUrl);
    xhr.setRequestHeader('Authorization', token);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = triggerDownloadOnResponse(xhr, '/files/multiple', onStart, onComplete, queryParams);
    // sort the files and folders in proper order and send them over to server
    var fileData = files.sort(fileSortingFn).map(function (_a) {
        var uuid = _a.uuid;
        return ({
            type: 'S3',
            value: uuid,
            includeFileReport: true
        });
    });
    var urlData = urls.map(function (url) { return ({
        type: 'API',
        value: url,
        includeFileReport: false
    }); });
    xhr.send(JSON.stringify(__spreadArray(__spreadArray([], fileData, true), urlData, true)));
};
exports.downloadFiles = downloadFiles;
var exportCSVFromFiles = function (token, files, urls, queryParams, onStart, onComplete) {
    if (urls === void 0) { urls = []; }
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('POST', shortenUrl);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', token);
    xhr.onreadystatechange = triggerDownloadOnResponse(xhr, '/files/export', onStart, onComplete, queryParams);
    var fileData = files
        .sort(fileSortingFn)
        .map(function (_a) {
        var uuid = _a.uuid;
        return ({ type: 'S3', value: uuid });
    })
        .concat(urls.map(function (url) { return ({ type: 'API', value: url }); }));
    xhr.send(JSON.stringify(fileData));
};
exports.exportCSVFromFiles = exportCSVFromFiles;
var downloadBlob = function (blob, fileName) {
    var url = window.URL.createObjectURL(blob);
    triggerLink(url, fileName);
    window.URL.revokeObjectURL(url);
};
exports.downloadBlob = downloadBlob;
var triggerDownloadOnResponse = function (req, downloadEndpoint, onStart, onComplete, queryParams) {
    return function () {
        if (req.readyState !== XMLHttpRequest.DONE || req.status !== 200)
            return;
        onStart === null || onStart === void 0 ? void 0 : onStart();
        var url = JSON.parse(req.response).url;
        var checkDownloadCookie = function () {
            var cookie = (0, cookies_1.getCookie)(url);
            cookie === 'LOADED' || cookie === undefined
                ? onComplete === null || onComplete === void 0 ? void 0 : onComplete()
                : setTimeout(checkDownloadCookie, 1000);
        };
        setTimeout(checkDownloadCookie, 1000);
        var params = new URLSearchParams(queryParams);
        var downloadUrl = new URL("".concat(downloadEndpoint, "/").concat(url, "?").concat(params), __UPLOADSERVERURL__);
        triggerLink(downloadUrl.toString());
    };
};
var triggerLink = function (url, fileName) {
    var anchor = document.createElement('a');
    anchor.href = url;
    if (fileName)
        anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
};
